module.exports = __webpack_public_path__ + "img/au.au54426ac.svg";